module.exports = __webpack_public_path__ + "static/media/logo_w.571edcad.png";